import axios from 'axios'
import { apiUrl } from "@/services/constants";

export const getRoomStatus = (id) => {
  return axios.get(`${apiUrl}/jitsi/status/${id}`);
};
